import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Modal } from 'react-bootstrap';

import Layout from '../../components/Layout';
import AuthUser from '../../components/AuthUser';
import { PedidosPorDiaTable } from '../../components/PedidosPorDiaTable';
import { TopClientes } from '../../components/modulos_gerente/TopClientes';
import { HistoricoCliente } from '../../components/modulos_gerente/HistoricoCliente';
import { TopVendedores } from '../../components/modulos_gerente/TopVendedores';
import { TopProductosSupervisor } from '../../components/modulos_gerente/TopProductosSupervisor';
import { CorteSemanalSupervisor } from '../../components/modulos_gerente/CorteSemanalSupervisor'
import { CobranzasGerencia } from '../../components/modulos_gerente/CobranzasGerencia'
import { ModulosSupervisor } from '../../data/menuData';
import { TopProductos } from '../../components/modulos_gerente/TopProductos';
import { TopProductos2 } from '../../components/modulos_gerente/TopProductos2';

import belmenyLogo from '../../assets/img/logoBG.webp';
import otherUserIcon from '../../assets/img/user-icon-resize.webp';
import notFoundImg from '../../assets/img/404-module-not-found-2.webp';
import { CircleUserRound, ChevronRight, ClipboardList, TrendingUp, TrendingDown, Pointer } from 'lucide-react';
import { RiCloseCircleFill } from "react-icons/ri";

import { getTotalClientesxSupervisor, getClientesAtendidosxZona, getVentasSupervisorVert, getVentasSupervisorIngco } from '../../api/requestClientes';
import { getTopVendedoresSupervisor, getPedidosAyer, getVendedoresXSupervisor, getZonasSupervisor, getCorteSemanalxZona, getVentasZona, getCantidadVentasxGerente, getPedidosPorVendedor, getVentasAnualesEnCursoSupervisores, getTopClientes, getCobranzasSupervisor, getFacturasVencidas, getFacturasEmitidas, getParetos, getClientesCaptados, getPorcentajeVendedores, getPorcentajeSupervisor, getCantidadVentasxVendedor, getCantidadVentasxVendedor2 } from '../../api/requestSupervisor';

import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';

import axios from 'axios';

import Chart from "react-apexcharts";
import { DateRangePicker, Stack } from 'rsuite';

import { startOfMonth, endOfMonth, addMonths, startOfWeek, endOfWeek, subWeeks, format, subDays } from 'date-fns';
import moment from 'moment/moment';

import { formatNumber } from '../../utils/formats';

// SVG LOGOS
import brokenImg from '../../assets/img/broken-image-general.png';

export const DashboardSupervisor = () => {

  useEffect(() => {
    loadVentas()
    CheckImg()
  }, []);



  // State del usuario
  const { user, getToken } = AuthUser();
  const navigate = useNavigate();
  const location = useLocation();

  // State del loading
  const [loading, setLoading] = useState(true);
  const [hasInitialized, setHasInitialized] = useState(false); //inicializar componente


  // States del modal
  const [fullscreen, setFullscreen] = useState(true);
  const [show, setShow] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalBody, setModalBody] = useState("");
  const [modalLoading, setModalLoading] = useState("");

  // State de datos
  const [username, setUsername] = useState('');
  const [userIcon, setUserIcon] = useState(``);
  const [zonaSelected, setZonaSelected] = useState('General');
  const [clienteSelected, setClienteSelected] = useState('');
  const [mesSelected, setMesSelected] = useState('');
  const [añoSelected, setAñoSelected] = useState(0);
  const [totalVendido, setTotalVendido] = useState(0)
  const [totalMeta, setTotalMeta] = useState(0)
  const [totalMetaAyer, setTotalMetaAyer] = useState(0)
  const [totalClientes, setTotalClientes] = useState(0)
  const [totalVendidoVert, setTotalVendidoVert] = useState(0)
  const [totalVendidoIngco, setTotalVendidoIngco] = useState(0)
  const [totalVendidoImou, setTotalVendidoImou] = useState(0)
  const [totalVendidoQuilosa, setTotalVendidoQuilosa] = useState(0)
  const [totalVendidoFleximatic, setTotalVendidoFleximatic] = useState(0)
  const [totalVendidoCorona, setTotalVendidoCorona] = useState(0)
  const [totalVendidoWadfow, setTotalVendidoWadfow] = useState(0)
  const [facturasEmitidas, setFacturasEmitidas] = useState(0);
  const [clientesCaptados, setClientesCaptados] = useState(0);
  const [resumenFacturado, setResumenFacturado] = useState(0);
  const [resumenAyer, setResumenAyer] = useState(0);
  const [resumenPedido, setResumenPedido] = useState(0);
  const [multipleTops, setMultipleTops] = useState(false);
  const [listVendedores, setListVendedores] = useState([]);
  const [zonasSupervisor, setZonasSupervisor] = useState([]);
  const [ventasSemanales, setVentasSemanales] = useState([]);
  const [ventasSemanalesOtrasZonas, setVentasSemanalesOtrasZonas] = useState([]);
  const [ventasGralZona, setVentasGralZona] = useState([]);
  const [ventasProductos, setVentasProductos] = useState([]);
  const [ventasProductos2, setVentasProductos2] = useState([]);
  const [pedidosPorDia, setPedidosPorDia] = useState([]);
  const [pedidosPorDiaAyer, setPedidosPorDiaAyer] = useState([]); // NUEVO
  const [facturasVencidas, setFacturasVencidas] = useState({});
  const [resultCobranzas2023, setResultCobranzas2023] = useState({})
  const [resultCobranzas2024, setResultCobranzas2024] = useState({})
  const [topClientes, setTopClientes] = useState({});
  const [topAllClientes, setTopAllClientes] = useState({});
  const [ventasAnualesData, setVentasAnualesData] = useState({});
  const [vxcChart, setVxcChart] = useState({});
  const [ventasZonaData, setVentasZonaData] = useState({});
  const [clientesChart, setClientesChart] = useState({})
  const [chartData2, setChartData2] = useState({});
  const [chartData3, setChartData3] = useState({});
  const [topData, setTopData] = useState({});
  const [topData2, setTopData2] = useState({});
  const [topData3, setTopData3] = useState({});
  const [porcentajeVendedor, setPorcentajeVendedor] = useState({});
  const [porcentajeSupervisor, setPorcentajeSupervisor] = useState({});
  const flete = 0.031

  // Calculate the start and end of the past week
  const pastWeekStart = startOfWeek(subWeeks(new Date(), 1), { weekStartsOn: 1 });
  const pastWeekEnd = endOfWeek(subWeeks(new Date(), 1), { weekStartsOn: 1 });

  // Calculate the start and end of the current week
  const [currentRange, setCurrentRange] = useState(null);

  const currentWeekStart = startOfWeek(new Date(), { weekStartsOn: 1 });
  const currentWeekEnd = endOfWeek(new Date(), { weekStartsOn: 1 });

  // Format the dates as required (dd/mm/yyyy)
  const formattedPastWeekStart = format(pastWeekStart, 'dd/MM');
  const formattedPastWeekEnd = format(pastWeekEnd, 'dd/MM');
  const formattedCurrentWeekStart = format(currentWeekStart, 'dd/MM');
  const formattedCurrentWeekEnd = format(currentWeekEnd, 'dd/MM');

  // Use the values in your state or wherever you need them
  const [startPastWeek, setStartPastWeek] = useState(formattedPastWeekStart);
  const [endPastWeek, setEndPastWeek] = useState(formattedPastWeekEnd);
  const [startCurrentWeek, setStartCurrentWeek] = useState(formattedCurrentWeekStart);
  const [endCurrentWeek, setEndCurrentWeek] = useState(formattedCurrentWeekEnd);
  const [startActualMonth, setStartActualMonth] = useState(format(startOfMonth(new Date()), 'yyyy-MM-dd HH:mm:ss'))
  const [endActualMonth, setEndActualMonth] = useState(format(endOfMonth(new Date()), 'yyyy-MM-dd HH:mm:ss'))
  const [startYesterday, setStartYesterday] = useState(() => {
    const yesterday = subDays(new Date(), 1);
    return format(yesterday, 'yyyy-MM-dd 00:00:00');
  });

  const [endYesterday, setEndYesterday] = useState(() => {
    const yesterday = subDays(new Date(), 1);
    return format(yesterday, 'yyyy-MM-dd 23:59:59');
  });
  const formatTs = date => format(date, 'yyyy-MM-dd HH:mm:ss');
  const [loadingAyer, setLoadingAyer] = useState(false);

  const predefinedRanges = [
    {
      label: 'Últimos 3 meses',
      value: [startOfMonth(addMonths(new Date(), -3)), endOfMonth(addMonths(new Date(), -1))],
      placement: 'bottom'
    },
    {
      label: 'Últimos 6 meses',
      value: [startOfMonth(addMonths(new Date(), -6)), endOfMonth(addMonths(new Date(), -1))],
      placement: 'bottom'
    },
    {
      label: 'Último año',
      value: [new Date(new Date().getFullYear() - 1, 0, 1), new Date(new Date().getFullYear(), 0, 0)],
      placement: 'bottom'
    }
  ];

  const { afterToday } = DateRangePicker;

  const labels = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];



  // Efecto “ayer”: corre al cambiar zona, pero SOLO si aún no hay currentRange
  useEffect(() => {
    // Si ya elegiste un rango, salimos y no recargamos “ayer”
    if (currentRange) return;

    // Aquí tu función que llama a la API para ayer
    cargarResumenAyer();
  }, [zonaSelected, currentRange]);


  // después de las declaraciones de state
  useEffect(() => {
    if (!currentRange) return;

    const start = formatTs(currentRange.start);
    const end = formatTs(currentRange.end);
    const zona = zonaSelected || 'General';

    (async () => {
      setLoading(true);
      // 2.1) llamada
      const res = await getPedidosPorVendedor(start, end, zona, user.CodVendedor);

      // 2.2) construyes filledData exactamente como lo hacías dentro de changeDate
      const dateRange = [];
      for (
        let d = new Date(currentRange.start);
        d <= currentRange.end;
        d.setDate(d.getDate() + 1)
      ) {
        dateRange.push(d.toISOString().slice(0, 10));
      }

      const uniqueVendors = new Map();
      const countPedidosMap = new Map();
      const totalPedidoMap = new Map();
      const totalFacturadoMap = new Map();

      res.nroPedidos.forEach(x => countPedidosMap.set(x.Vendedor, x.nroPedidos));
      res.nroPedidos.forEach(x => totalPedidoMap.set(x.Vendedor, x.TotalPedido));
      res.nroFacturas.forEach(x => totalFacturadoMap.set(x.CodigoVendedor, x.TotalFacturado));

      // arma lista de vendors con sus totales
      const updated = res.pedidosPorVendedor.map(item => ({
        ...item,
        nroPedidos: countPedidosMap.get(item.CodVendedor) || 0,
        TotalPedido: totalPedidoMap.get(item.CodVendedor) || 0,
        TotalFacturado: totalFacturadoMap.get(item.CodVendedor) || 0,
      }));
      updated.forEach(v => {
        if (!uniqueVendors.has(v.CodVendedor)) {
          uniqueVendors.set(v.CodVendedor, {
            CodVendedor: v.CodVendedor,
            Nombre: v.Nombre,
            nroPedidos: v.nroPedidos,
            TotalPedido: v.TotalPedido,
            TotalFacturado: v.TotalFacturado
          });
        }
      });

      // rellena fechas sin pedidos
      const filledData = [];
      uniqueVendors.forEach(vendor => {
        dateRange.forEach(fecha => {
          const found = updated.find(e => e.CodVendedor === vendor.CodVendedor && e.Fecha === fecha);
          if (found) {
            filledData.push({ Pedidos: found.Pedidos, ...vendor, Fecha: fecha });
          } else {
            filledData.push({ Pedidos: 0, ...vendor, Fecha: fecha });
          }
        });
      });

      filledData.sort((a, b) => {
        if (a.CodVendedor !== b.CodVendedor) {
          return a.CodVendedor.localeCompare(b.CodVendedor);
        }
        return new Date(a.Fecha) - new Date(b.Fecha);
      });

      // 2.3) sets definitivos
      setPedidosPorDia(filledData);
      const sumPedidos = res.nroPedidos.reduce((acc, x) => acc + Number(x.TotalPedido), 0);
      const sumFacturas = res.nroFacturas.reduce((acc, x) => acc + Number(x.TotalFacturado), 0);
      const flete = 0.031;
      setResumenPedido(sumPedidos);
      setResumenFacturado(sumFacturas);

      setLoading(false);
    })();
  }, [currentRange, zonaSelected]);

  useEffect(() => {
    if (location.state?.openModal) {
      // Abre el modal con el botón correspondiente
      handleButtonClick(location.state.openModal);
      // Limpia el state para que no reaparezca si refrescas
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state]); // solo al cambiar state

  const cargarResumenAyer = async () => {
    setLoadingAyer(true);

    const zona = zonaSelected || 'General';
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const start = formatTs(new Date(yesterday.setHours(0, 0, 0)));
    const end = formatTs(new Date(yesterday.setHours(23, 59, 59)));

    try {
      const res = await getPedidosPorVendedor(start, end, zona, user.CodVendedor);

      // Construye filledData solo para ayer
      const dateKey = start.slice(0, 10);
      const countMap = new Map(res.nroPedidos.map(x => [x.Vendedor, x.nroPedidos]));
      const totalMap = new Map(res.nroPedidos.map(x => [x.Vendedor, x.TotalPedido]));
      const factMap = new Map(res.nroFacturas.map(x => [x.CodigoVendedor, x.TotalFacturado]));

      const filledData = res.pedidosPorVendedor.map(item => ({
        Fecha: dateKey,
        CodVendedor: item.CodVendedor,
        Nombre: item.Nombre,
        Pedidos: item.Pedidos,
        nroPedidos: countMap.get(item.CodVendedor) || 0,
        TotalPedido: totalMap.get(item.CodVendedor) || 0,
        TotalFacturado: factMap.get(item.CodVendedor) || 0,
      }));

      setPedidosPorDiaAyer(filledData);
    } finally {
      setLoadingAyer(false);
    }
  };




  const handleImageError = (event) => {
    event.target.src = brokenImg;
  };

  const handleButtonClick = (buttonId) => {
    setShow(true);
    switch (buttonId) {
      case 'pedidosPorDia':
        setModalTitle("Resumen de pedidos por día")
        setModalBody("pedidosPorDia")
        setModalLoading("resumen de pedidos por día")
        break;
      case 'corteSemanal':
        setModalTitle("Corte semanal")
        setModalBody("corteSemanal")
        setModalLoading("corte semanal")
        break;
      case 'ranking':
        setModalTitle("Top 10 vendedores del mes")
        setModalBody("rankingVendedores")
        setModalLoading("top de vendedores")
        break;
      case 'cobranzasZona':
        setModalTitle("Cobranzas por Zona")
        setModalBody("cobranzasZona")
        setModalLoading("cobranzas por zona")
        break;
      case 'topClientes':
        setModalTitle("Top Clientes")
        setModalBody("topClientes")
        setModalLoading("top de clientes")
        break;
      case 'topAllClientes':
        loadTopAllClientes()
        setModalTitle("Top Clientes")
        setModalBody("topAllClientes")
        setModalLoading("top de clientes")
        break;
      case 'topProductos':
        setModalTitle("Top Productos")
        setModalBody("topProductos")
        setModalLoading("top de productos")
        break;
      case 'topProductos2':
        setModalTitle("Top Productos")
        setModalBody("topProductos2")
        setModalLoading("top de productos2")
        break;
      case 'topVendedores':
        setModalTitle("Top Vendedores")
        setModalBody("topVendedores")
        setModalLoading("top de vendedores")
        break;
      case 'cobranzasGerencia':
        setModalTitle("Cobranzas de gerencia")
        setModalBody("cobranzasGerencia")
        setModalLoading("sus cobranzas")
        break;
      case 'historicoCliente':
        setModalTitle("Historico del Cliente")
        setModalBody("historicoCliente")
        setModalLoading("historico del cliente")
        break;
      default:
        setModalTitle("Resumen de pedidos por día")
        setModalBody("pedidosPorDia")
        setModalLoading("resumen de pedidos por día")
        break;
    }
  };

  const CheckImg = async () => {
    await axios.get(`https://belmeny.com/fotos_vendedores/${user.CodVendedor}.jpeg`).then(() => {
      setUserIcon(`https://belmeny.com/fotos_vendedores/${user.CodVendedor}.jpeg`)
      return true;
    })
      .catch(() => {
        setUserIcon(otherUserIcon)
        return false;
      });
  }

  const changeDate = async (e) => {
    setLoading(true)
    let date = JSON.stringify(e)
    let start = date.slice(2, 12) + " 00:00:00"
    let end = date.slice(29, 39) + " 23:59:59"

    let resCalendar;
    let resCalendarAyer;

    if (zonaSelected === 'General') {
      resCalendar = await getPedidosPorVendedor(start, end, 'General', user.CodVendedor)
    } else {
      resCalendar = await getPedidosPorVendedor(start, end, zonaSelected, user.CodVendedor)
    }

    //  setPedidosPorDia(resCalendar.pedidosPorVendedor)
    //setResumenPedido(resCalendar.totalPedido)         // o como venga tu API
    // setResumenFacturado(resCalendar.totalFacturado)   // idem

    // Define your desired date range based on start and end dates
    const startDate = new Date(start);
    const endDate = new Date(end);
    setCurrentRange({ start: startDate, end: endDate });

    // Create an array of dates within the date range
    const dateRange = [];
    for (let currentDate = startDate; currentDate <= endDate; currentDate.setDate(currentDate.getDate() + 1)) {
      dateRange.push(currentDate.toISOString().slice(0, 10));
    }

    // Create a set of unique dates from your data
    const uniqueDates = new Set(resCalendar.pedidosPorVendedor.map(entry => entry.Fecha));

    // Create a list of vendors
    const uniqueVendors = new Map();
    // Create a mapping of Vendedor or CodVendedor to their corresponding data
    const totalPedidoMap = new Map();
    const totalFacturadoMap = new Map();
    const countPedidosMap = new Map();

    resCalendar.nroPedidos.forEach(item => {
      countPedidosMap.set(item.Vendedor, item.nroPedidos);
    })

    resCalendar.nroPedidos.forEach(item => {
      totalPedidoMap.set(item.Vendedor, item.TotalPedido);
    });

    resCalendar.nroFacturas.forEach(item => {
      totalFacturadoMap.set(item.CodigoVendedor, item.TotalFacturado);
    });

    // Add TotalPedido and TotalFacturado to each item in pedidosPorVendedor
    const updatedPedidosPorVendedor = resCalendar.pedidosPorVendedor.map(item => {
      const codVendedor = item.CodVendedor;

      return {
        ...item,
        nroPedidos: countPedidosMap.get(codVendedor) || 0,
        TotalPedido: totalPedidoMap.get(codVendedor) || 0,
        TotalFacturado: totalFacturadoMap.get(codVendedor) || 0,
      };
    });

    // Iterate over vendors and dates to fill in missing entries
    updatedPedidosPorVendedor.forEach(vendor => {
      // If the vendor is not already in the map, add it
      if (!uniqueVendors.has(vendor.CodVendedor)) {
        uniqueVendors.set(vendor.CodVendedor, { CodVendedor: vendor.CodVendedor, Nombre: vendor.Nombre, nroPedidos: vendor.nroPedidos, TotalPedido: vendor.TotalPedido, TotalFacturado: vendor.TotalFacturado });
      }
    });

    // Create a new array to store the filled data
    const filledData = [];

    // Iterate over unique vendors and dates to fill in missing entries
    uniqueVendors.forEach(vendor => {
      dateRange.forEach(date => {
        const existingEntry = updatedPedidosPorVendedor.find(entry => entry.CodVendedor === vendor.CodVendedor && entry.Fecha === date);
        if (existingEntry) {
          filledData.push({ Pedidos: existingEntry.Pedidos, CodVendedor: vendor.CodVendedor, Nombre: vendor.Nombre, Fecha: date, nroPedidos: vendor.nroPedidos, TotalPedido: vendor.TotalPedido, TotalFacturado: vendor.TotalFacturado });
        } else {
          // If the entry is missing, add it with 0 orders
          filledData.push({ Pedidos: 0, CodVendedor: vendor.CodVendedor, Nombre: vendor.Nombre, Fecha: date, nroPedidos: vendor.nroPedidos, TotalPedido: vendor.TotalPedido, TotalFacturado: vendor.TotalFacturado });
        }
      });
    });

    // Sort the filledData array by 'CodVendedor' (vendor code) and then by 'Fecha' (date)
    filledData.sort((a, b) => {
      if (a.CodVendedor !== b.CodVendedor) {
        return a.CodVendedor.localeCompare(b.CodVendedor); // Sort by vendor code
      } else {
        const dateA = new Date(a.Fecha);
        const dateB = new Date(b.Fecha);
        return dateA - dateB; // Sort by date
      }
    });

    setPedidosPorDia(filledData);
    const totalFactSinFlete = resCalendar.nroFacturas.reduce((acc, factura) => acc + factura.TotalFacturado, 0);
    const totalPedSinFlete = resCalendar.nroPedidos.reduce((acc, factura) => acc + factura.TotalPedido, 0);
    setResumenFacturado(totalFactSinFlete);
    setResumenPedido(totalPedSinFlete);

    setLoading(false)
  }

  const loadTopAllClientes = async () => {
    setLoading(true)
    const resTopClientes = await getTopClientes(user.CodVendedor)
    const topDeClientes = await resTopClientes
    setTopAllClientes(topDeClientes)
    setLoading(false)
  }

  const loadVentas = async () => {
    setUsername(user.CodGerente)
    const porcentajeVendedor = await getPorcentajeVendedores(user.CodVendedor)
    setPorcentajeSupervisor(await getPorcentajeSupervisor(user.CodVendedor))
    const [resListaVendedores, resZonasSup, resVentasxZona, resCorteSemanal, resCorteSemanalOtrasZonas, resClientesFacturados, resVentasYCantidad, resTotalClientes, resVentasAnualesEnCurso, resTopClientes, resCobranza2026, resCobranza2025, resFacturasVencidas, resFacturasEmitidas, resClientesCaptados] = await Promise.all([getVendedoresXSupervisor(user.CodVendedor), getZonasSupervisor(user.CodVendedor), getVentasZona(user.CodVendedor), getCorteSemanalxZona(user.CodVendedor), getCorteSemanalxZona(user.CodVendedor, 'si'), getClientesAtendidosxZona(user.CodVendedor), getCantidadVentasxGerente(user.CodVendedor), getTotalClientesxSupervisor(user.CodVendedor), getVentasAnualesEnCursoSupervisores(user.CodVendedor), getParetos(user.CodVendedor, null, "Facturado"), getCobranzasSupervisor(user.CodVendedor, 2026), getCobranzasSupervisor(user.CodVendedor, 2025), getFacturasVencidas(user.CodVendedor), getFacturasEmitidas(user.CodVendedor), getClientesCaptados(user.CodVendedor)])
    const vxc = await getCantidadVentasxVendedor(user.CodVendedor);
    const vxc2 = await getCantidadVentasxVendedor2(user.CodVendedor);
    // vxc ahora contiene el resultado de la promesa
    // No necesitas Promise.all
    // Usa vxc
    const listaVendedores = await resListaVendedores;
    const zonasSup = await resZonasSup;
    const ventasxZona = await resVentasxZona;
    const corteSemanal = await resCorteSemanal;
    const corteSemanalOtrasZonas = await resCorteSemanalOtrasZonas;
    const clientesFacturados = await resClientesFacturados;
    const ventasYCantidad = await resVentasYCantidad;
    const totClientes = await resTotalClientes;
    const ventasAnuales = await resVentasAnualesEnCurso
    const topClientes = await resTopClientes
    const resCobranzasGral2023 = await resCobranza2026 //Enrealidad es 2025 pero el hardcodeo de Diego hizo que sea una tarea titanica cambiar los 2023 asi que se queda asi
    const resCobranzasGral2024 = await resCobranza2025
    const facturasVencidas = await resFacturasVencidas
    const facturasEmitidas = await resFacturasEmitidas;
    const clientesCapts = await resClientesCaptados;

    setVentasProductos2(vxc2)
    setListVendedores(listaVendedores)
    setZonasSupervisor(zonasSup)
    setVentasSemanales(corteSemanal)
    setVentasSemanalesOtrasZonas(corteSemanalOtrasZonas)
    setVentasGralZona(ventasxZona)
    setVentasProductos(ventasYCantidad)
    setTotalClientes(totClientes);
    setTopClientes(topClientes)
    setZonaSelected("General")
    setResultCobranzas2023(resCobranzasGral2023)
    setResultCobranzas2024(resCobranzasGral2024)
    setFacturasVencidas(facturasVencidas)
    setFacturasEmitidas(facturasEmitidas.FacturasEmitidas)
    setClientesCaptados(clientesCapts.ClientesCaptados)

    const ventasingco2026 = await getVentasSupervisorIngco('2026', user.CodVendedor)
    const ventasvert2026 = await getVentasSupervisorVert('2026', user.CodVendedor)

    function sortByMonth(arr) {
      var months = ["ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO",
        "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"];
      arr.sort(function (a, b) {
        return months.indexOf(a.mes)
          - months.indexOf(b.mes);
      });
    }

    function calcularDiasDelMesActual() {
      const fechaActual = new Date(); // Obtiene la fecha y hora actual

      // Obtiene el año actual
      const anioActual = fechaActual.getFullYear();

      // Obtiene el mes actual (0-11, así que hay que sumar 1 para el mes real)
      const mesActual = fechaActual.getMonth(); // Enero es 0, Febrero es 1, etc.

      // Creamos una fecha para el primer día del *siguiente* mes.
      // Esto nos permite "ir hacia atrás" para obtener el último día del mes actual.
      // new Date(año, mes, día)
      // Al poner '0' como día, JavaScript interpreta que es el último día del mes anterior.
      const primerDiaDelSiguienteMes = new Date(anioActual, mesActual + 1, 0);

      // El día de esta fecha es el número de días del mes actual.
      const diasDelMes = primerDiaDelSiguienteMes.getDate();

      return diasDelMes;
    }


    sortByMonth(ventasingco2026)
    sortByMonth(ventasvert2026)

    setPorcentajeVendedor({
      options: {
        chart: {
          id: "chart-porcentajeVendedor",
          type: "bar"
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            borderRadiusApplication: 'end',
            horizontal: true,
          }
        },
        xaxis: {
          categories: porcentajeVendedor.map((cliente) => cliente.Nombre)
        },
        colors: ['#fba10b', '#0041ff'],

      },
      series: [{
        name: 'Porcentaje de compra de INGCO',
        data: porcentajeVendedor.map((cliente) => cliente.porcentaje_ingco)
      },
      {
        name: 'Porcentaje de compra de VERT',
        data: porcentajeVendedor.map((cliente) => cliente.porcentaje_vert)
      }]
    })

    const getArrayDiff = (data) => { //Ordena la data para ingco mensual
      var datosArr = [
        {
          months: 'ENERO',
          ventas: 0,
          year: data[0].year,
        },
        {
          months: 'FEBRERO',
          ventas: 0,
          year: data[0].year,
        },
        {
          months: 'MARZO',
          ventas: 0,
          year: data[0].year,
        },
        {
          months: 'ABRIL',
          ventas: 0,
          year: data[0].year,
        },
        {
          months: 'MAYO',
          ventas: 0,
          year: data[0].year,
        },
        {
          months: 'JUNIO',
          ventas: 0,
          year: data[0].year,
        },
        {
          months: 'JULIO',
          ventas: 0,
          year: data[0].year,
        },
        {
          months: 'AGOSTO',
          ventas: 0,
          year: data[0].year,
        },
        {
          months: 'SEPTIEMBRE',
          ventas: 0,
          year: data[0].year,
        },
        {
          months: 'OCTUBRE',
          ventas: 0,
          year: data[0].year,
        },
        {
          months: 'NOVIEMBRE',
          ventas: 0,
          year: data[0].year,
        },
        {
          months: 'DICIEMBRE',
          ventas: 0,
          year: data[0].year,
        }
      ]

      const completeArray = datosArr.map(monthObj => {
        const matchingData = data.find(dataObj => dataObj.months === monthObj.months && dataObj.year === monthObj.year);
        return { ...monthObj, ventas: matchingData?.ventas_ingco || 0 };
      });

      return completeArray;
    }

    const getArrayDiff2 = (data) => { //Ordena la data para vert mensual
      var datosArr = [
        {
          months: 'ENERO',
          ventas: 0,
          year: data[0].year,
        },
        {
          months: 'FEBRERO',
          ventas: 0,
          year: data[0].year,
        },
        {
          months: 'MARZO',
          ventas: 0,
          year: data[0].year,
        },
        {
          months: 'ABRIL',
          ventas: 0,
          year: data[0].year,
        },
        {
          months: 'MAYO',
          ventas: 0,
          year: data[0].year,
        },
        {
          months: 'JUNIO',
          ventas: 0,
          year: data[0].year,
        },
        {
          months: 'JULIO',
          ventas: 0,
          year: data[0].year,
        },
        {
          months: 'AGOSTO',
          ventas: 0,
          year: data[0].year,
        },
        {
          months: 'SEPTIEMBRE',
          ventas: 0,
          year: data[0].year,
        },
        {
          months: 'OCTUBRE',
          ventas: 0,
          year: data[0].year,
        },
        {
          months: 'NOVIEMBRE',
          ventas: 0,
          year: data[0].year,
        },
        {
          months: 'DICIEMBRE',
          ventas: 0,
          year: data[0].year,
        }
      ]

      const completeArray = datosArr.map(monthObj => {
        const matchingData = data.find(dataObj => dataObj.months === monthObj.months && dataObj.year === monthObj.year);
        return { ...monthObj, ventas: matchingData?.ventas_vert || 0 };
      });

      return completeArray;
    }

    const arr2026 = getArrayDiff(ventasingco2026)
    const arr2_2026 = getArrayDiff2(ventasvert2026)

    setChartData2({
      options: {
        chart: {
          id: "chart-VentasIngcoAnuales",
          type: "area"
        },
        xaxis: {
          categories: labels
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 90, 100]
          }
        },
        colors: ['#fba10b'],
        dataLabels: {
          enabled: false
        },
      },
      series: [
        {
          name: 'Ventas del año 2026 en %',
          data: arr2026.map((Ventas) => Ventas.ventas)
        },
      ]
    })

    setChartData3({
      options: {
        chart: {
          id: "chart-VentasVertAnuales",
          type: "area"
        },
        xaxis: {
          categories: labels
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 90, 100]
          }
        },
        colors: ['#0041ff'],
        dataLabels: {
          enabled: false
        },
      },
      series: [
        {
          name: 'Ventas del año 2026 en %',
          data: arr2_2026.map((Ventas) => Ventas.ventas)
        },
      ]
    })

    // Bar chart ventas del mes
    setVentasZonaData({
      options: {
        chart: {
          id: "chart-VentasZona",
        },
        xaxis: {
          categories: ventasxZona.map((Zona) => {
    // Aseguramos que los valores sean números, si son null o undefined usamos 0
    const vendido = Zona.total_vendido || 0;
    const meta = Zona.meta_zona || 0;
    
    // Aplicamos tu factor de ajuste (3.1%)
    const vendidoAjustado = vendido - (vendido * 0.031);
    
    // Calculamos el porcentaje solo si la meta es mayor a 0 para evitar división por cero
    const porcentaje = meta > 0 
        ? ((vendidoAjustado * 100) / meta).toFixed(2) 
        : "0.00";

    return `${Zona.Sector} - ${meta} USD ≈ ${porcentaje}%`;
})
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: false,
          }
        },
        colors: ['#27ae60'],
        dataLabels: {
          formatter: function (val, opt) {
            const goals =
              opt.w.config.series[opt.seriesIndex].data[opt.dataPointIndex]
                .goals
            if (goals && goals.length) {
              return `${val} / ${goals[0].value}`
            }
            return val
          },
          enabled: true,
          style: {
            colors: ['#000']
          }
        },
        legend: {
          show: true,
          showForSingleSeries: true,
          customLegendItems: ['Ventas actuales', 'Ventas esperadas'],
          markers: {
            fillColors: ['#27ae60', '#e74c3c']
          }
        }
      },
      series: [
        {
          name: 'Ventas en USD',
          data: ventasxZona.map((Zona) => {
    // 1. Validamos que existan valores numéricos (si es null, usamos 0)
    const vendido = Zona.total_vendido || 0;
    const meta = Zona.meta_zona || 0;

    // 2. Realizamos el cálculo matemático (Venta - 3.1%)
    const resultadoCalculado = vendido - (vendido * 0.031);

    return {
        x: Zona.Sector,
        // 3. Aplicamos toFixed solo al resultado final para el gráfico
        y: parseFloat(resultadoCalculado.toFixed(2)), 
        goals: [
            {
                name: 'Meta en USD',
                value: meta,
                strokeWidth: 85,
                strokeHeight: 5,
                strokeLineCap: 'round',
                strokeColor: '#e74c3c'
            }
        ]
    };
})
        }
      ]
    })

    // Donut chart de clientes facturados en el mes
    setClientesChart({
      options:
      {
        labels: clientesFacturados.map((Zona) => `${Zona.Sector}`), // Replace with your own labels
        legend: {
          show: true,
          position: "bottom",
        },
        plotOptions: {
          pie: {
            donut: {
              size: "70%",
              labels: {
                show: true
              }
            },
            dataLabels: {
              enabled: true,
            },
          },
        },
      },
      series: clientesFacturados.map((Zona) => Zona.uniqueClientes)
    })

    const resCalendar = await getPedidosPorVendedor(startYesterday, endYesterday, 'General', user.CodVendedor)
    const resCalendarAyer = await getPedidosAyer(startActualMonth, endActualMonth, 'General');

    // Create a set of unique dates
    const uniqueDates = new Set(resCalendar.pedidosPorVendedor.map(entry => entry.Fecha));

    // Create a list of vendors
    const uniqueVendors = new Map();
    // Create a mapping of Vendedor or CodVendedor to their corresponding data
    const totalPedidoMap = new Map();
    const totalFacturadoMap = new Map();
    const countPedidosMap = new Map();

    resCalendar.nroPedidos.forEach(item => {
      countPedidosMap.set(item.Vendedor, item.nroPedidos);
    })

    resCalendar.nroPedidos.forEach(item => {
      totalPedidoMap.set(item.Vendedor, item.TotalPedido);
    });

    resCalendar.nroFacturas.forEach(item => {
      totalFacturadoMap.set(item.CodigoVendedor, item.TotalFacturado);
    });

    // Add TotalPedido and TotalFacturado to each item in pedidosPorVendedor
    const updatedPedidosPorVendedor = resCalendar.pedidosPorVendedor.map(item => {
      const codVendedor = item.CodVendedor;

      return {
        ...item,
        nroPedidos: countPedidosMap.get(codVendedor) || 0,
        TotalPedido: totalPedidoMap.get(codVendedor) || 0,
        TotalFacturado: totalFacturadoMap.get(codVendedor) || 0,
      };
    });

    // Iterate over vendors and dates to fill in missing entries
    updatedPedidosPorVendedor.forEach(vendor => {
      // If the vendor is not already in the map, add it
      if (!uniqueVendors.has(vendor.CodVendedor)) {
        uniqueVendors.set(vendor.CodVendedor, { CodVendedor: vendor.CodVendedor, Nombre: vendor.Nombre, nroPedidos: vendor.nroPedidos, TotalPedido: vendor.TotalPedido, TotalFacturado: vendor.TotalFacturado });
      }
    });

    // Create a new array to store the filled data
    const filledData = [];

    // Iterate over unique vendors and dates to fill in missing entries
    uniqueVendors.forEach(vendor => {
      uniqueDates.forEach(date => {
        const existingEntry = updatedPedidosPorVendedor.find(entry => entry.CodVendedor === vendor.CodVendedor && entry.Fecha === date);
        if (existingEntry) {
          filledData.push({ Pedidos: existingEntry.Pedidos, CodVendedor: vendor.CodVendedor, Nombre: vendor.Nombre, Fecha: date, nroPedidos: vendor.nroPedidos, TotalPedido: vendor.TotalPedido, TotalFacturado: vendor.TotalFacturado });
        } else {
          // If the entry is missing, add it with 0 orders
          filledData.push({ Pedidos: 0, CodVendedor: vendor.CodVendedor, Nombre: vendor.Nombre, Fecha: date, nroPedidos: vendor.nroPedidos, TotalPedido: vendor.TotalPedido, TotalFacturado: vendor.TotalFacturado });
        }
      });
    });

    // Sort the filledData array by 'CodVendedor' (vendor code) and then by 'Fecha' (date)
    filledData.sort((a, b) => {
      if (a.CodVendedor !== b.CodVendedor) {
        return a.CodVendedor.localeCompare(b.CodVendedor); // Sort by vendor code
      } else {
        const dateA = new Date(a.Fecha);
        const dateB = new Date(b.Fecha);
        return dateA - dateB; // Sort by date
      }
    });

    setPedidosPorDia(filledData);
    const totalFactSinFlete = resCalendar.nroFacturas.reduce((acc, factura) => acc + Number(factura.TotalFacturado), 0);
    const totalPedSinFlete = resCalendar.nroPedidos.reduce((acc, factura) => acc + Number(factura.TotalPedido), 0);
    let totalPedAyer = 0;

    if (resCalendarAyer?.length > 0) {
      const supervisorAyer = resCalendarAyer.find(item => item.CodSupervisor === user.CodVendedor);
      if (supervisorAyer) {
        totalPedAyer = supervisorAyer.TotalPedido;
      } else {
        console.warn("No se encontró información para el supervisor actual.");
      }
    } else {
      console.warn("No se encontraron pedidos para el día anterior");
    }



    setResumenFacturado(totalFactSinFlete);
    setResumenPedido(totalPedSinFlete);
    setResumenAyer(totalPedAyer);

    // Sumatoria total de metas
    let metasSum = 0
    for (let i = 0; i < ventasxZona.length; i++) {
      metasSum += ventasxZona[i].meta_zona;
    }
    setTotalMeta(metasSum)
    const diasDelMesActual = calcularDiasDelMesActual();
    const promedioPorDia = (metasSum / diasDelMesActual);
    setTotalMetaAyer(promedioPorDia)
    // Sumatoria de las ventas
    let vendidoSum = 0
    for (let i = 0; i < ventasxZona.length; i++) {
      vendidoSum += ventasxZona[i].total_vendido;
    }

    // Aqui se empezaba a cuadrar todo sin flete, pero ahora lo cuadro completo, por cambios en decision
    let vendidoSinFlete = vendidoSum
    let vendidoVert = ventasYCantidad[0]?.TotalVendidoVert ?? 0;
    let vendidoIngco = ventasYCantidad[0]?.TotalVendidoIngco ?? 0;
    let vendidoImou = ventasYCantidad[0]?.TotalVendidoImou ?? 0;
    let vendidoQuilosa = ventasYCantidad[0]?.TotalVendidoQuilosa ?? 0;
    let vendidoFleximatic = ventasYCantidad[0]?.TotalVendidoFleximatic ?? 0;
    let vendidoCorona = ventasYCantidad[0]?.TotalVendidoCorona ?? 0;
    let vendidoWadfow = ventasYCantidad[0]?.TotalVendidoWadfow ?? 0;

    setTotalVendido(vendidoSinFlete)
    setTotalVendidoVert(vendidoVert)
    setTotalVendidoIngco(vendidoIngco)
    setTotalVendidoImou(vendidoImou)
    setTotalVendidoQuilosa(vendidoQuilosa)
    setTotalVendidoFleximatic(vendidoFleximatic)
    setTotalVendidoCorona(vendidoCorona)
    setTotalVendidoWadfow(vendidoWadfow)

    // Division de top de zonas
    if (zonasSup.length > 1) {
      setMultipleTops(true)

      const [resTopZona1, resTopZona2, resTopZona3] = await Promise.all([getTopVendedoresSupervisor(user.CodVendedor, zonasSup[0].Sector), getTopVendedoresSupervisor(user.CodVendedor, zonasSup[1].Sector), getTopVendedoresSupervisor(user.CodVendedor, zonasSup[2].Sector)])

      const TopChart1 = await resTopZona1;
      const TopChart2 = await resTopZona2;
      const TopChart3 = await resTopZona3;

      setTopData({
        options: {
          chart: {
            id: "chart-TopVendedores",
            type: 'bar',
          },
          xaxis: {
            categories: TopChart1.map((Vendedor) => Vendedor.Nombre),
          },
          legend: {
            show: true,
            position: 'bottom'
          },
          dataLabels: {
            enabled: true,
            style: {
              colors: ['#000']
            }
          },
          plotOptions: {
            bar: {
              borderRadius: 4,
              horizontal: true,
              distributed: true,
              labels: {
                show: true
              },
              dataLabels: {
                formatter: function (val, opt) {
                  const goals =
                    opt.w.config.series[opt.seriesIndex].data[opt.dataPointIndex]
                      .goals
                  if (goals && goals.length) {
                    return `${val} / ${goals[0].value}`
                  }
                  return val
                },
                enabled: true,
                style: {
                  colors: ['#000']
                }
              },
            },
          },
          colors: TopChart1.map((Vendedor) => Vendedor.ventas_vendedor < Vendedor.global / 2 ? '#ff0000b3' : Vendedor.ventas_vendedor < Vendedor.global * 0.8 ? '#fe9c1299' : '#27ae60b3'),
        },
        series: [
          {
            name: 'Ventas en USD',
            data: TopChart1.map((Vendedor) => {
              // 1. Las constantes van aquí arriba (dentro de las llaves del map)
              const ventas = Vendedor.ventas_vendedor || 0;
              const valorAjustado = ventas - (ventas * 0.031);
              const meta = Vendedor.global || 0;

              // 2. Tienes que usar "return" para devolver el objeto
              return {
                x: Vendedor.Nombre,
                y: Number(valorAjustado.toFixed(2)),
                goals: [
                  {
                    name: 'Meta en USD',
                    value: meta,
                    strokeWidth: 10,
                    strokeHeight: 0,
                    strokeLineCap: 'round',
                    strokeColor: '#e74c3c'
                  }
                ]
              };
            })
          }
        ]
      })

      setTopData2({
        options: {
          chart: {
            id: "chart-TopVendedores",
            type: 'bar',
          },
          xaxis: {
            categories: TopChart2.map((Vendedor) => Vendedor.Nombre),
          },
          legend: {
            show: true,
            position: 'bottom'
          },
          dataLabels: {
            enabled: true,
            style: {
              colors: ['#000']
            }
          },
          plotOptions: {
            bar: {
              borderRadius: 4,
              horizontal: true,
              distributed: true,
              labels: {
                show: true
              },
            },
          },
          colors: TopChart2.map((Vendedor) => Vendedor.ventas_vendedor < Vendedor.global / 2 ? '#ff0000b3' : Vendedor.ventas_vendedor < Vendedor.global * 0.8 ? '#fe9c1299' : '#27ae60b3'),
        },
        series: [
          {
            name: 'Ventas en USD',
            data: TopChart2.map((Vendedor) => {
              // 1. Manejo de valores nulos o indefinidos
              const ventas = Vendedor.ventas_vendedor || 0;
              const meta = Vendedor.global || 0;

              // 2. Cálculo matemático limpio
              const valorNeto = ventas - (ventas * 0.031);

              // 3. Retorno del objeto para el gráfico
              return {
                x: Vendedor.Nombre,
                // Convertimos a número para evitar problemas de formato en el eje Y
                y: Number(valorNeto.toFixed(2)),
                goals: [
                  {
                    name: 'Meta en USD',
                    value: meta,
                    strokeWidth: 10,
                    strokeHeight: 0,
                    strokeLineCap: 'round',
                    strokeColor: '#e74c3c'
                  }
                ]
              };
            })
          }
        ]
      })

      setTopData3({
        options: {
          chart: {
            id: "chart-TopVendedores",
            type: 'bar',
          },
          xaxis: {
            categories: TopChart3.map((Vendedor) => Vendedor.Nombre),
          },
          legend: {
            show: true,
            position: 'bottom'
          },
          dataLabels: {
            enabled: true,
            style: {
              colors: ['#000']
            }
          },
          plotOptions: {
            bar: {
              borderRadius: 4,
              horizontal: true,
              distributed: true,
              labels: {
                show: true
              },
            },
          },
          colors: TopChart3.map((Vendedor) => Vendedor.ventas_vendedor < Vendedor.global / 2 ? '#ff0000b3' : Vendedor.ventas_vendedor < Vendedor.global * 0.8 ? '#fe9c1299' : '#27ae60b3'),
        },
        series: [
          {
            name: 'Ventas en USD',
            data: TopChart3.map((Vendedor) => {
              // 1. Manejo seguro de valores (si es null, usamos 0)
              const ventas = Vendedor.ventas_vendedor || 0;
              const metaGlobal = Vendedor.global || 0;

              // 2. Cálculo matemático (Ventas - 3.1%)
              const valorAjustado = ventas - (ventas * 0.031);

              return {
                x: Vendedor.Nombre,
                // 3. Convertimos a número para asegurar que el gráfico lo lea bien
                y: Number(valorAjustado.toFixed(2)),
                goals: [
                  {
                    name: 'Meta en USD',
                    value: metaGlobal,
                    strokeWidth: 10,
                    strokeHeight: 0,
                    strokeLineCap: 'round',
                    strokeColor: '#e74c3c'
                  }
                ]
              };
            })
          }
        ]
      })

    } else {
      const TopChart1 = await getTopVendedoresSupervisor(user.CodVendedor, zonasSup[0].Sector)

      setTopData({
        options: {
          chart: {
            id: "chart-TopVendedores",
            type: 'bar',
          },
          xaxis: {
            categories: TopChart1.map((Vendedor) => Vendedor.Nombre),
          },
          legend: {
            show: true,
            position: 'bottom'
          },
          plotOptions: {
            bar: {
              borderRadius: 4,
              horizontal: true,
              distributed: true,
              labels: {
                show: true
              },
              dataLabels: {
                enabled: false
              },
            },
          },
          colors: TopChart1.map((Vendedor) => Vendedor.ventas_vendedor < Vendedor.global / 2 ? '#ff0000b3' : Vendedor.ventas_vendedor < Vendedor.global * 0.8 ? '#fe9c1299' : '#27ae60b3'),
        },
        series: [
          {
            name: 'Ventas en USD',
            data: TopChart1.map((Vendedor) => {
              // 1. Aseguramos que los valores sean números (si es null, usamos 0)
              const ventas = Vendedor.ventas_vendedor || 0;
              const metaGlobal = Vendedor.global || 0;

              // 2. Calculamos el valor ajustado
              const valorAjustado = ventas - (ventas * 0.031);

              return {
                x: Vendedor.Nombre,
                // 3. Convertimos a número para que el gráfico no tenga problemas
                y: Number(valorAjustado.toFixed(2)),
                goals: [
                  {
                    name: 'Meta en USD',
                    value: metaGlobal,
                    strokeWidth: 10,
                    strokeHeight: 0,
                    strokeLineCap: 'round',
                    strokeColor: '#e74c3c'
                  }
                ]
              };
            })
          }
        ]
      })
    }

    const sortedVentasAnuales = ventasAnuales.map(venta => {
      const sortedData = Object.keys(venta)
        .sort()
        .reduce((obj, key) => {
          obj[key] = venta[key];
          return obj;
        }, {});
      return sortedData;
    });

    const seriesData = sortedVentasAnuales.map(venta => {
      // Usamos una validación más robusta para el valor de la venta
      const data = labels.map(label => {
        const valor = venta[label];
        // Si el valor es null, undefined o no es un número, usamos 0
        return (valor === null || valor === undefined) ? 0 : parseFloat(valor.toFixed(2));
      });

      return {
        name: `Ventas de ${venta.Sector} en USD`,
        data: data
      };
    });

    setVentasAnualesData({
      options: {
        chart: {
          id: "chart-VentasAnuales",
          type: "area"
        },
        xaxis: {
          categories: labels
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 90, 100]
          }
        },
        colors: ['#52d689', '#0041ff', '#d62915'],
        dataLabels: {
          enabled: false
        },
      },
      series: seriesData
    })

    const sumCantidadProductosVert = vxc.reduce((acc, productos) => {
      const cantidadProductos = productos.CantidadProductosVert;
      return typeof cantidadProductos === 'number' ? acc + cantidadProductos : acc + 0;
    }, 0);

    const sumCantidadProductosIngco = vxc.reduce((acc, productos) => {
      const cantidadProductos = productos.CantidadProductosIngco;
      return typeof cantidadProductos === 'number' ? acc + cantidadProductos : acc + 0;
    }, 0);

    const sumCantidadProductosImou = vxc.reduce((acc, productos) => {
      const cantidadProductos = productos.CantidadProductosImou;
      return typeof cantidadProductos === 'number' ? acc + cantidadProductos : acc + 0;
    }, 0);

    const sumCantidadProductosWadfow = vxc.reduce((acc, productos) => {
      const cantidadProductos = productos.CantidadProductosWadfow;
      return typeof cantidadProductos === 'number' ? acc + cantidadProductos : acc + 0;
    }, 0);

    const sumCantidadProductosQuilosa = vxc.reduce((acc, productos) => {
      const cantidadProductos = productos.CantidadProductosQuilosa;
      return typeof cantidadProductos === 'number' ? acc + cantidadProductos : acc + 0;
    }, 0);

    const sumCantidadProductosFleximatic = vxc.reduce((acc, productos) => {
      const cantidadProductos = productos.CantidadProductosFleximatic;
      return typeof cantidadProductos === 'number' ? acc + cantidadProductos : acc + 0;
    }, 0);

    const sumCantidadProductosCorona = vxc.reduce((acc, productos) => {
      const cantidadProductos = productos.CantidadProductosCorona;
      return typeof cantidadProductos === 'number' ? acc + cantidadProductos : acc + 0;
    }, 0);

    /*const sumCantidadProductosPOP = vxc.reduce((acc, productos) => {
      const cantidadProductos = productos.CantidadProductosPOP;
      return typeof cantidadProductos === 'number' ? acc + cantidadProductos : acc + 0;
    }, 0);*/

    setVxcChart({
      options:
      {
        labels: ["Vërt", "Ingco", "Imou", "Wadfow", "Quilosa", "Fleximatic", "Corona"],
        legend: {
          show: true,
          position: "bottom",
        },
        plotOptions: {
          pie: {
            donut: {
              size: "70%",
              labels: {
                show: false
              }
            },
            dataLabels: {
              enabled: true,
            },
          },
        },
        colors: ['#0041ff', '#fba10b', '#F18D00', '#0033A1', '#001242', '#001242', '#0069B4']
      },
      series: [sumCantidadProductosVert, sumCantidadProductosIngco, sumCantidadProductosImou, sumCantidadProductosWadfow, sumCantidadProductosQuilosa, sumCantidadProductosFleximatic, sumCantidadProductosCorona]
    })

    setLoading(false)
  }


  return (
    <>
      <Layout>
        <div className="container-fluid">
          {
            (loading) ?
              <>
                <div style={{ position: 'fixed', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
                  <div className="loader-book">
                    <div>
                      <ul>
                        <li>
                          <svg fill="currentColor" viewBox="0 0 90 120">
                            <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
                          </svg>
                        </li>
                        <li>
                          <svg fill="currentColor" viewBox="0 0 90 120">
                            <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
                          </svg>
                        </li>
                        <li>
                          <svg fill="currentColor" viewBox="0 0 90 120">
                            <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
                          </svg>
                        </li>
                        <li>
                          <svg fill="currentColor" viewBox="0 0 90 120">
                            <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
                          </svg>
                        </li>
                        <li>
                          <svg fill="currentColor" viewBox="0 0 90 120">
                            <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
                          </svg>
                        </li>
                        <li>
                          <svg fill="currentColor" viewBox="0 0 90 120">
                            <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
                          </svg>
                        </li>
                      </ul>
                    </div>
                    <span>Cargando estadisticas...</span>
                  </div>
                </div>
              </> :
              <>
                {/* --- VISTA MÓVIL FUNCIONAL --- */}
                <div className="d-sm-block d-md-none p-3">

                  {/* Header usuario compacto */}
                  <div className="d-flex align-items-center mb-3">
                    <img src={userIcon} alt="user" onError={handleImageError} className="rounded-circle me-2" style={{ width: 48, height: 48, border: "2px solid rgba(0,41,117,1)" }} />
                    <div>
                      <div style={{ fontWeight: 700 }}>{user.Nombre}</div>
                      <small className="text-muted">Supervisor</small>
                    </div>
                    <div className="ms-auto text-end">
                      <button className="btn btn-sm btn-outline-primary" onClick={() => handleButtonClick('pedidosPorDia')}>Pedidos</button>
                    </div>
                  </div>

                  {/* Metrics compactas (scroll horizontal si excede) */}
                  <div className="d-flex gap-2 overflow-auto mb-3" style={{ paddingBottom: 6 }}>
                    <div className="card p-2 text-center" style={{ minWidth: 160 }}>
                      <small className="text-muted">Meta mes</small>
                      {/* Aseguramos que totalMeta sea un número */}
                      <div className="fw-bold">${formatNumber(totalMeta || 0)}</div>

                      {/* CORRECCIÓN AQUÍ: Protegemos totalVendido antes del toFixed */}
                      <small className="text-muted">
                        Facturado: ${formatNumber(Number(totalVendido || 0).toFixed(2))}
                      </small>
                    </div>
                    <div className="card p-2 text-center" style={{ minWidth: 160 }}>
                      <small className="text-muted">Pedidos ayer</small>
                      <div className="fw-bold">${formatNumber(resumenAyer)}</div>
                      <small className={totalMetaAyer > resumenAyer ? 'text-danger' : 'text-success'}>Meta diaria: ${formatNumber(totalMetaAyer)}</small>
                    </div>
                    <div className="card p-2 text-center" style={{ minWidth: 160 }}>
                      <small className="text-muted">Facturas vencidas</small>
                      <div className="fw-bold">{facturasVencidas?.Vencidas_30_Dias ?? 0}</div>
                      <small className="text-muted">Más 30d</small>
                    </div>
                    <div className="card p-2 text-center" style={{ minWidth: 160 }}>
                      <small className="text-muted">Clientes captados</small>
                      <div className="fw-bold">{clientesCaptados ?? 0}</div>
                      <small className="text-muted">Este mes</small>
                    </div>
                  </div>

                  {/* Mini charts / thumbnails (click para ver detalles en modal) */}
                  <div className="mb-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <h6 className="mb-0">Ventas (zona)</h6>
                      <button className="btn btn-sm btn-link" onClick={() => handleButtonClick('topVendedores')}>Ver</button>
                    </div>
                    {/* renderiza solo si tienes datos para no romper render */}
                    {ventasZonaData?.series ? (
                      (() => {
                        // calcula un minWidth dinámico: 140px por zona (ajusta si quieres más/menos)
                        const zoneCount = ventasZonaData.series[0]?.data?.length ?? 0;
                        const minWidth = zoneCount > 0 ? Math.max(zoneCount * 120, 320) : '100%';

                        const mobileOptions = {
                          ...ventasZonaData.options,
                          chart: {
                            ...ventasZonaData.options.chart,
                            toolbar: { show: false },
                            // altura base para móvil
                            height: 160
                          },
                          dataLabels: { enabled: false }, // evita etiquetas encima de las barras
                          legend: { show: false },
                          xaxis: {
                            ...ventasZonaData.options.xaxis,
                            labels: {
                              // rotar y recortar etiquetas largas
                              ...(ventasZonaData.options.xaxis?.labels || {}),
                              rotate: -45,
                              trim: true,
                              hideOverlappingLabels: true,
                              maxHeight: 60
                            }
                          },
                          plotOptions: {
                            ...ventasZonaData.options.plotOptions,
                            bar: {
                              ...(ventasZonaData.options.plotOptions?.bar || {}),
                              horizontal: false, // en móvil mejor vertical y scrollear horizontalmente
                              borderRadius: 4
                            }
                          },
                          // responsive tweak: aún más agresivo por debajo de 576px
                          responsive: [
                            {
                              breakpoint: 576,
                              options: {
                                chart: { height: 200 },
                                plotOptions: { bar: { horizontal: false } },
                                dataLabels: { enabled: false },
                                legend: { show: false },
                                xaxis: { labels: { rotate: -45, trim: true } }
                              }
                            }
                          ]
                        };

                        return (
                          <div style={{ height: 200, overflowX: 'auto' }}>
                            <div style={{ minWidth }}>
                              <Chart
                                options={mobileOptions}
                                series={ventasZonaData.series}
                                type="bar"
                                width={typeof minWidth === 'number' ? `${minWidth}px` : '100%'}
                                height="180px"
                              />
                            </div>
                          </div>
                        );
                      })()
                    ) : <div className="text-muted small">No hay datos</div>}

                  </div>

                  <div className="mb-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <h6 className="mb-0">Top productos (mensual)</h6>
                      <button className="btn btn-sm btn-link" onClick={() => handleButtonClick('topProductos2')}>Ver</button>
                    </div>
                    {vxcChart?.series ? (
                      <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Chart
                          options={{ ...vxcChart.options, legend: { show: false } }}
                          series={vxcChart.series}
                          type="pie"
                          width="220px"
                          height="160px"
                        />
                      </div>
                    ) : <div className="text-muted small">No hay datos</div>}
                  </div>

                  {/* Top clientes compact list (primeros 5) */}
                  <div className="mb-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <h6 className="mb-0">Top clientes</h6>
                      <div>
                        <button className="btn btn-sm btn-outline-secondary me-1" onClick={() => handleButtonClick('topAllClientes')}>Todos</button>
                        <button className="btn btn-sm btn-primary" onClick={() => handleButtonClick('topClientes')}>Paretos</button>
                      </div>
                    </div>

                    {topClientes?.data?.length > 0 ? (
                      <div className="list-group">
                        {topClientes.data.slice(0, 5).map((c, i) => (
                          <div key={c.CodigoCliente || i} className="list-group-item list-group-item-action d-flex justify-content-between align-items-start">
                            <div className="me-2" style={{ minWidth: 0 }}>
                              <div className="fw-bold text-truncate" style={{ maxWidth: 160 }}>{c.NombreCliente}</div>
                              <small className="text-muted">{c.NombreVendedor} · {c.Sector}</small>
                            </div>
                            <div className="text-end">
                              <div className="fw-bold">
                                {formatNumber(
                                  // Nos aseguramos que el resultado de la operación sea un número antes de usar toFixed
                                  Number(((c.Facturado ?? 0) * (1 - (flete ?? 0)))).toFixed(2)
                                )} USD
                              </div>
                              <button
                                className="btn btn-sm btn-link p-0"
                                onClick={() => {
                                  setClienteSelected(c.CodigoCliente);
                                  handleButtonClick('historicoCliente');
                                }}
                              >
                                Hist
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="text-center text-muted small">No hay información de clientes</div>
                    )}
                  </div>

                  {/* Accesos rápidos inferiores */}
                  <div className="d-grid gap-2">
                    <button className="btn btn-outline-primary" onClick={() => handleButtonClick('cobranzasGerencia')}>Cobranzas</button>
                    <button className="btn btn-outline-secondary" onClick={() => handleButtonClick('corteSemanal')}>Corte semanal</button>
                  </div>

                </div>

                {/* Div para web */}
                <div className='d-none d-md-block'>
                  <div className="container-fluid rounded">
                    <div className="row my-3">
                      <div className="col">
                        <span>
                          <h5><span className="badge rounded bg-primary">Inicio</span> <ChevronRight size={20} color="#000000" absoluteStrokeWidth /> <a href="/dashboard-supervisor">Panel de control</a></h5>
                        </span>
                      </div>
                      <div className="col text-end text-belmeny">
                        <div className="row">
                          <div className="col offset-6">
                            <img src={userIcon} alt="No se ha cargado la imagen..." className='float-end drop-shadow rounded-circle' style={{ width: "60px", height: "60px", border: "3px solid rgba(0, 41, 117, 1)" }} />
                          </div>
                          <div className="col d-flex align-items-center justify-content-center">
                            <h4>{user.Nombre}</h4>
                          </div>
                          {/* PEDIDOS */}

                          <div className="text-belmeny top-0 right-0 p-4" >
                            <h4><span onClick={() => handleButtonClick('pedidosPorDia')} style={{ cursor: "pointer" }}>Total Usd$ Pedidos:</span></h4>
                            <h5><span onClick={() => handleButtonClick('pedidosPorDia')} style={{ cursor: "pointer" }}>Dia Anterior: ${formatNumber(resumenAyer)}</span></h5>
                            {totalMetaAyer > resumenAyer ? (
                              // Si totalMetaAyer es MAYOR que resumenAyer, el texto es ROJO
                              <h5><span onClick={() => handleButtonClick('pedidosPorDia')} style={{ color: 'red', cursor: "pointer" }}>Meta Diaria: ${formatNumber(totalMetaAyer)}</span></h5>
                            ) : (
                              // Si totalMetaAyer es MENOR o IGUAL que resumenAyer, el texto es VERDE
                              <h5><span onClick={() => handleButtonClick('pedidosPorDia')} style={{ color: 'green', cursor: "pointer" }}>Meta Diaria: ${formatNumber(totalMetaAyer)}</span></h5>
                            )}
                          </div>

                        </div>
                      </div>
                    </div>

                    {/* Initial stats */}
                    <div className="row">


                      {/* Facturado */}
                      <div className="col-2 bg-white drop-shadow-card p-3 rounded">
                        <div className="ms-2 text-belmeny">
                          <h4>Ventas del mes:</h4>
                          <h6 className='fw-normal'>USD</h6>
                          {/* Agregamos || 0 para evitar errores si la meta no carga */}
                          <h5>Meta: ${formatNumber(totalMeta || 0)}</h5>
                          {/* PROTECCIÓN CRÍTICA: Aseguramos que sea número antes del toFixed */}
                          <h5>Facturado: ${formatNumber(Number(totalVendido || 0).toFixed(2))}</h5>
                        </div>
                      </div>
                      <div className="col bg-white drop-shadow-card p-3 rounded mx-3">
                        <h4>Facturas vencidas:</h4>
                        <div className="row">
                          <div className="col">
                            <h6 className='fw-normal'>USD</h6>
                            <h5 className="text-danger">
                              {facturasVencidas?.Vencidas_1_15_Dias || 0} facturas -
                              ${formatNumber(Number(facturasVencidas?.Vencidas_1_15_Dias_TotalNeto || 0).toFixed(2))}
                            </h5>
                            <h6 className='fw-normal'>1 - 15 días</h6>
                          </div>

                          <div className="col">
                            <h6 className='fw-normal'>USD</h6>
                            <h5 className="text-danger">
                              {facturasVencidas?.Vencidas_15_29_Dias || 0} facturas -
                              ${formatNumber(Number(facturasVencidas?.Vencidas_15_29_Dias_TotalNeto || 0).toFixed(2))}
                            </h5>
                            <h6 className='fw-normal'>16 - 30 días</h6>
                          </div>

                          <div className="col">
                            <h6 className='fw-normal'>USD</h6>
                            <h5 className="text-danger">
                              {facturasVencidas?.Vencidas_30_Dias || 0} facturas -
                              ${formatNumber(Number(facturasVencidas?.Vencidas_30_Dias_TotalNeto || 0).toFixed(2))}
                            </h5>
                            <h6 className='fw-normal'>Más de 30 días</h6>
                          </div>
                        </div>
                      </div>
                      <div className="col-3 bg-white drop-shadow-card p-3 rounded">
                        <div className="row">
                          <h4>Facturas emitidas este mes:</h4>
                          <h5 className="text-belmeny">{facturasEmitidas} Facturas</h5>
                        </div>
                        <div className="row">
                          <h4>Clientes captados este mes:</h4>
                          <h5 className="text-belmeny">{clientesCaptados} Clientes</h5>
                        </div>
                      </div>
                    </div>

                    {/* CHART VENTAS DEL AÑO EN CURSO */}
                    <div className="row my-4">
                      <div className='col bg-white rounded drop-shadow-card me-3'>
                        <div className="h-100 p-2">
                          <h4 className="text-center text-belmeny fst-italic">Ventas anuales</h4>
                          <Chart
                            options={ventasAnualesData.options}
                            series={ventasAnualesData.series}
                            type="area"
                            width="100%"
                            height="450px"
                          />
                        </div>
                      </div>
                      <div className="col-3 drop-shadow-card">
                        <ModulosSupervisor>
                          {(buttonId) => handleButtonClick(buttonId)}
                        </ModulosSupervisor>
                      </div>
                    </div>

                    {/* Ventas zona y chart de clientes */}
                    <div className="row">
                      <div className='col drop-shadow-card'>
                        <div className="bg-white rounded h-100 p-2">
                          <h4 className="text-center text-belmeny fst-italic pt-2">Ventas del mes</h4>
                          <h5 className="text-center text-belmeny">Meta general a lograr: {formatNumber(totalMeta)} USD
                          </h5>
                          <Chart
                            options={ventasZonaData.options}
                            series={ventasZonaData.series}
                            type="bar"
                            width="100%"
                            height="100%"
                          />
                        </div>
                      </div>
                      <div className="col bg-white rounded drop-shadow-card me-3">
                        <div className="row mt-2 mb-3">
                          <div className="col">
                            <h4 className="text-center text-belmeny fst-italic pt-2">Top Clientes</h4>
                          </div>
                          <div className="col-3 text-end">
                            <button className="btn btn-hover-details" onClick={(e) => handleButtonClick('topClientes')}>Ver detalles paretos</button>
                          </div>
                          <div className="col-3 text-end">
                            <button className="btn btn-hover-details" onClick={(e) => handleButtonClick('topAllClientes')}>Ver todos los clientes</button>
                          </div>
                        </div>
                        {
                          <>
                            <div className="row my-3 px-3">
                              <div className="col text-start">
                                <h6 className='text-belmeny text-truncate' style={{ maxWidth: "450px" }}>Clientes</h6>
                              </div>
                              <div className="col-2 my-auto">
                                <h6 className='text-center text-belmeny'>Máximo Facturado por mes 2025</h6>
                              </div>
                              <div className="col-1 my-auto">
                                <h6 className='text-center text-belmeny'>-</h6>
                              </div>
                              <div className="col-2 my-auto">
                                <h6 className="text-center text-belmeny">Facturado</h6>
                              </div>
                              <div className="col-2 my-auto">
                                <h6 className="text-center text-belmeny">Opciones</h6>
                              </div>
                            </div>
                            {
                              (topClientes.data.length > 0) ?
                                (topClientes.data.slice(0, 10).map((cliente, idx) =>
                                  <div className="row my-3 px-3" key={idx}>
                                    <div className="col-5 text-start">
                                      <h6 className='text-belmeny text-truncate' style={{ maxWidth: "400px" }}>{cliente.NombreCliente}</h6>
                                      <h6 className='text-muted fw-normal fst-italic'>{cliente.NombreVendedor} - {cliente.Sector}</h6>
                                    </div>
                                    <div className="col-2 my-auto">
                                      <h6 className='text-center text-success'>
                                        {formatNumber(
                                          (() => {
                                            // 1. Extraemos el valor y aseguramos que sea un número (si es null, usamos 0)
                                            const valorBase = cliente.Maximo_Facturado || 0;
                                            // 2. Realizamos el cálculo matemático (Restamos el 3.1%)
                                            const valorNeto = valorBase - (valorBase * 0.031);
                                            // 3. Formateamos a 2 decimales solo al final
                                            return valorNeto.toFixed(2);
                                          })()
                                        )} USD
                                      </h6>
                                      <h6 className='text-muted fw-normal fst-italic text-center'>
                                        {cliente.Mes || 'Mes no definido'}
                                      </h6>
                                    </div>
                                    <div className="col-1 my-auto">
                                      <h6 className='text-center text-success'>-</h6>
                                    </div>
                                    <div className="col-2 my-auto">
                                      {(() => {
                                        // 1. Definimos valores seguros (si son null o undefined, usamos 0)
                                        const facturado = cliente.Facturado || 0;
                                        const maximo = cliente.Maximo_Facturado || 0;

                                        // 2. Lógica de color (Clases CSS)
                                        let colorClass = 'text-center text-success';
                                        if (facturado < maximo * 0.4) {
                                          colorClass = 'text-center text-danger';
                                        } else if (facturado < maximo * 0.6) {
                                          colorClass = 'text-center text-warning';
                                        }

                                        // 3. Cálculo matemático (Venta - 3.1%)
                                        const valorNeto = (facturado - (facturado * 0.031)).toFixed(2);

                                        return (
                                          <>
                                            <h6 className={colorClass}>
                                              {formatNumber(valorNeto)} USD
                                            </h6>
                                            <h6 className='text-muted fw-normal fst-italic text-center'>
                                              Mes en curso
                                            </h6>
                                          </>
                                        );
                                      })()}
                                    </div>
                                    <div className="col-2 my-auto">
                                      <button className='btn btn-hover-details' onClick={(e) => { handleButtonClick('historicoCliente'); setClienteSelected(cliente.CodigoCliente) }}>Ver Historico</button>
                                    </div>
                                  </div>
                                )) : <h4 className="text-center text-belmeny fst-italic mt-5 alert alert-info">No hay información de clientes paretos existente...</h4>
                            }
                            <h6 className='text-muted fw-normal fst-italic text-center'>Nota: El monto cambiará de color según el % en relación con el máximo facturado</h6>
                            <h6 className='text-muted fw-normal fst-italic text-center'>De 0% a 40% se refleja en <span className="text-danger fw-bold">rojo</span></h6>
                            <h6 className='text-muted fw-normal fst-italic text-center'>De 41% a 59% se refleja en <span className="text-warning fw-bold">amarillo</span></h6>
                            <h6 className='text-muted fw-normal fst-italic text-center'>Más del 60% se refleja en <span className="text-success fw-bold">verde</span></h6>
                          </>
                        }
                      </div>
                    </div>

                    <div className="division my-5"></div>

                    {/* Cobranzas por vendedor */}
                    <div className="mb-5 bg-white rounded drop-shadow-card rounded p-3">
                      <h4 className="text-center text-belmeny fst-italic mb-1">Cobranzas de su gerencia</h4>
                      <h6 className="text-muted fst-italic fw-normal text-center">Las gráficas serán mostradas dependiendo si el mes tiene una deuda pendiente.</h6>
                      <div className="accordion mt-2" id="accordionCobranzas">
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingLastYear">
                            <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseLastYear" aria-expanded="true" aria-controls="collapseLastYear">
                              <h5 className="text-belmeny fst-italic text-center mt-2">Año 2026</h5>
                            </button>
                          </h2>
                          <div id="collapseLastYear" className="accordion-collapse collapse show" aria-labelledby="headingLastYear" data-bs-parent="#accordionCobranzas">
                            <div className="accordion-body">
                              {
                                resultCobranzas2023.map((result, idx) =>
                                  idx % 4 === 0 ? (
                                    <div key={idx} className="row mb-2">
                                      {[0, 1, 2, 3].map((colIdx) => {
                                        const currentIndex = idx + colIdx;
                                        // 1. Extraemos los datos del 2023 de forma segura
                                        const cobranza2023 = resultCobranzas2023[currentIndex] || { Pagado: 0, Pendiente: 0 };

                                        const pagado2023 = cobranza2023.Pagado || 0;
                                        const pendiente2023 = cobranza2023.Pendiente || 0;
                                        const total2023 = pagado2023 + pendiente2023;

                                        // 2. Calculamos los porcentajes (si el total es 0, evitamos NaN)
                                        const porcPagado2023 = total2023 > 0 ? ((pagado2023 * 100) / total2023).toFixed(2) : "0.00";
                                        const porcPendiente2023 = total2023 > 0 ? ((pendiente2023 * 100) / total2023).toFixed(2) : "0.00";
                                        if (currentIndex < resultCobranzas2023.length && resultCobranzas2023[currentIndex].Pendiente > 0) {
                                          return (
                                            <div key={currentIndex} className="col">
                                              <h5 className="text-center text-belmeny text-capitalize">{resultCobranzas2023[currentIndex].Mes}</h5>
                                              <Chart
                                                options={{
                                                  labels: [`${porcPagado2023}% Pagado`, `${porcPendiente2023}% Pendiente`],
                                                  legend: {
                                                    show: true,
                                                    position: "bottom",
                                                  },
                                                  plotOptions: {
                                                    pie: {
                                                      pie: {
                                                        labels: {
                                                          show: true
                                                        }
                                                      },
                                                      dataLabels: {
                                                        enabled: true,
                                                      },
                                                    },
                                                  },
                                                  colors: ['#27ae60b3', '#ff0000b3']
                                                }}
                                                series={[resultCobranzas2023[currentIndex].Pagado, resultCobranzas2023[currentIndex].Pendiente]}
                                                type="pie"
                                                width="350px"
                                                className="d-flex align-middle justify-content-center"
                                              />
                                              <button className='buttonMonths w-100 my-2' onClick={(e) => {
                                                handleButtonClick("cobranzasGerencia")
                                                setMesSelected(resultCobranzas2023[currentIndex].Mes)
                                                setAñoSelected(resultCobranzas2023[currentIndex].Año)
                                              }}><span>Ver detalles de</span> <span className="text-capitalize">{resultCobranzas2023[currentIndex].Mes}</span></button>
                                            </div>
                                          );
                                        } else {
                                          return null;
                                        }
                                      })}
                                    </div>
                                  ) : null
                                )
                              }
                            </div>
                          </div>
                        </div>
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingActualYear">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseActualYear" aria-expanded="false" aria-controls="collapseActualYear">
                              <h5 className="text-belmeny fst-italic text-center mt-2">Año 2025</h5>
                            </button>
                          </h2>
                          <div id="collapseActualYear" className="accordion-collapse collapse" aria-labelledby="headingActualYear" data-bs-parent="#accordionCobranzas">
                            <div className="accordion-body">
                              {
                                resultCobranzas2024.map((result, idx) =>
                                  idx % 4 === 0 ? (
                                    <div key={idx} className="row mb-2">
                                      {[0, 1, 2, 3].map((colIdx) => {
                                        const currentIndex = idx + colIdx;
                                        // 1. Extraemos los valores con seguridad usando el operador || 0
                                        const datosActuales = resultCobranzas2024[currentIndex] || {};
                                        const pagado = datosActuales.Pagado || 0;
                                        const pendiente = datosActuales.Pendiente || 0;
                                        const total = pagado + pendiente;

                                        // 2. Calculamos porcentajes evitando la división por cero
                                        const porcPagado = total > 0 ? ((pagado * 100) / total).toFixed(2) : "0.00";
                                        const porcPendiente = total > 0 ? ((pendiente * 100) / total).toFixed(2) : "0.00";
                                        if (currentIndex < resultCobranzas2024.length && resultCobranzas2024[currentIndex].Pendiente > 0) {
                                          return (
                                            <div key={currentIndex} className="col">
                                              <h5 className="text-center text-belmeny text-capitalize">{resultCobranzas2024[currentIndex].Mes}</h5>
                                              <Chart
                                                options={{
                                                  labels: [`${porcPagado}% Pagado`, `${porcPendiente}% Pendiente`],
                                                  legend: {
                                                    show: true,
                                                    position: "bottom",
                                                  },
                                                  plotOptions: {
                                                    pie: {
                                                      pie: {
                                                        labels: {
                                                          show: true
                                                        }
                                                      },
                                                      dataLabels: {
                                                        enabled: true,
                                                      },
                                                    },
                                                  },
                                                  colors: ['#27ae60b3', '#ff0000b3']
                                                }}
                                                series={[resultCobranzas2024[currentIndex].Pagado, resultCobranzas2024[currentIndex].Pendiente]}
                                                type="pie"
                                                width="350px"
                                                className="d-flex align-middle justify-content-center"
                                              />
                                              <button className='buttonMonths w-100 my-2' onClick={(e) => {
                                                handleButtonClick("cobranzasGerencia")
                                                setMesSelected(resultCobranzas2024[currentIndex].Mes)
                                                setAñoSelected(resultCobranzas2024[currentIndex].Año)
                                              }}><span>Ver detalles de</span> <span className="text-capitalize">{resultCobranzas2024[currentIndex].Mes}</span></button>
                                            </div>
                                          );
                                        } else {
                                          return null;
                                        }
                                      })}
                                    </div>
                                  ) : null
                                )
                              }
                            </div>
                          </div>
                        </div>
                        <div className='mt-3 text-belmeny division' />
                        <div className="row">

                          <div className="m-auto" style={{ width: "102%" }}>
                            <h5 className="text-center text-belmeny mt-4">Porcentaje de Top 100 Productos Vendido por Vendedor</h5>
                            <h5 className="text-center text-ingco">Promedio INGCO: {porcentajeSupervisor.porcen_ingco}%</h5>
                            <h5 className="text-center text-belmeny">Promedio VERT: {porcentajeSupervisor.porcen_vert}%</h5>
                            <Chart
                              options={porcentajeVendedor.options}
                              series={porcentajeVendedor.series}
                              type="bar"
                              width="100%"
                              height="1000px"
                            />

                          </div>
                          <div className="bg-belmeny division my-3"></div>
                          <div className="col text-end">
                            <button className="btn btn-hover-details" onClick={(e) => handleButtonClick('topProductos2')}>Ver detalles</button>
                          </div>
                          <h5 className="text-center text-belmeny mt-4">Porcentaje de Productos Mensual</h5>
                          <Chart
                            options={vxcChart.options}
                            series={vxcChart.series}
                            type="pie"
                            width="100%"
                            height="500px"
                          />
                          <div className="bg-belmeny division my-3"></div>
                          <h5 className="text-center text-belmeny mt-4">Porcentaje de Top 100 Productos Ingco Anual</h5>
                          <Chart
                            options={chartData2.options}
                            series={chartData2.series}
                            type="area"
                            width="100%"
                            height="300px"
                          />
                          <div className="bg-belmeny division my-3"></div>
                          <h5 className="text-center text-belmeny mt-4">Porcentaje de Top 100 Productos Vert Anual</h5>
                          <Chart
                            options={chartData3.options}
                            series={chartData3.series}
                            type="area"
                            width="100%"
                            height="500px"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
          }
        </div>
      </Layout>

      <Modal show={show} fullscreen={fullscreen} onHide={() => setShow(false)}>
        <Modal.Header className='bg-belmeny text-light'>
          <Modal.Title className='fst-italic'>{modalTitle}</Modal.Title>
          <Modal.Title>
            <RiCloseCircleFill className='text-danger fs-1 modal-close bg-light rounded-circle' onClick={() => setShow(false)} />
          </Modal.Title>
        </Modal.Header>
        <div className="division w-100 my-2 bg-belmeny"></div>
        <Modal.Body>

          <div className="container-fluid">
            {/* Div para escritorio */}
            <div className='d-none d-md-block d-lg-block'>

              {
                (loading) ?
                  <div style={{ position: 'fixed', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
                    <div className="loader-book">
                      <div>
                        <ul>
                          <li>
                            <svg fill="currentColor" viewBox="0 0 90 120">
                              <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
                            </svg>
                          </li>
                          <li>
                            <svg fill="currentColor" viewBox="0 0 90 120">
                              <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
                            </svg>
                          </li>
                          <li>
                            <svg fill="currentColor" viewBox="0 0 90 120">
                              <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
                            </svg>
                          </li>
                          <li>
                            <svg fill="currentColor" viewBox="0 0 90 120">
                              <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
                            </svg>
                          </li>
                          <li>
                            <svg fill="currentColor" viewBox="0 0 90 120">
                              <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
                            </svg>
                          </li>
                          <li>
                            <svg fill="currentColor" viewBox="0 0 90 120">
                              <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
                            </svg>
                          </li>
                        </ul>
                      </div>
                      <span>Cargando {modalLoading}...</span>
                    </div>
                  </div> :
                  <>
                    {
                      (modalBody === 'pedidosPorDia') ?
                        <>
                          <div className="row my-4">
                            {
                              zonasSupervisor.map((Zona) =>
                                <div className='col'>
                                  <button className='buttonMonths w-100' onClick={(e) => setZonaSelected(Zona.Sector)}><span className="text-white">{Zona.Sector}</span>
                                  </button>
                                </div>)
                            }
                            <div className="col"><button className='buttonMonths w-100' onClick={(e) => setZonaSelected('General')}><span className="text-white">General</span></button></div>
                          </div>
                          <h5 className='text-belmeny my-2 ps-2'>Zona seleccionada: {zonaSelected}</h5>
                          <Stack direction="row" spacing={10} alignItems="flex-start" className='mb-3'>
                            <DateRangePicker
                              appearance={"subtle"}
                              ranges={predefinedRanges}
                              placeholder="Buscar por fecha"
                              style={{ width: 300 }}
                              onChange={([startDate, endDate]) => {
                                setCurrentRange({ start: startDate, end: endDate });
                              }}
                              value={[currentRange?.start, currentRange?.end]}
                              className="border rounded-pill mb-2"
                              showOneCalendar
                              disabledDate={afterToday()}
                            />
                          </Stack>
                          <PedidosPorDiaTable key={zonaSelected + (currentRange ? 'RANGO' : 'AYER')} data={currentRange ? pedidosPorDia : pedidosPorDiaAyer} resumenFacturado={resumenFacturado} resumenPedido={resumenPedido} />
                        </> : (modalBody === 'topClientes') ?
                          <TopClientes topClientes={topClientes} supervisor={user.CodVendedor} loaded={'paretos'} />
                          : (modalBody === 'topAllClientes') ?
                            <TopClientes topClientes={topAllClientes} supervisor={user.CodVendedor} loaded={'todos'} />
                            : (modalBody === 'topVendedores') ?
                              <TopVendedores zonasSupervisor={zonasSupervisor} multipleTops={multipleTops} topData={topData} topData2={topData2} topData3={topData3} />
                              : (modalBody === 'topProductos') ?
                                <TopProductosSupervisor totalVendido={totalVendido} ventasProductos={ventasProductos} totalVendidoVert={totalVendidoVert} totalVendidoIngco={totalVendidoIngco} totalVendidoQuilosa={totalVendidoQuilosa} totalVendidoImou={totalVendidoImou} totalVendidoFleximatic={totalVendidoFleximatic} totalVendidoCorona={totalVendidoCorona} totalVendidoWadfow={totalVendidoWadfow} />
                                : (modalBody === 'corteSemanal') ?
                                  <CorteSemanalSupervisor startPastWeek={startPastWeek} endPastWeek={endPastWeek} startCurrentWeek={startCurrentWeek} endCurrentWeek={endCurrentWeek} zonasSupervisor={zonasSupervisor} ventasSemanales={ventasSemanales} ventasGralZona={ventasGralZona} ventasSemanalesOtrasZonas={ventasSemanalesOtrasZonas} />
                                  : (modalBody === 'cobranzasGerencia') ?
                                    <CobranzasGerencia mes={mesSelected} año={añoSelected} />
                                    : (modalBody === 'historicoCliente') ?
                                      <HistoricoCliente cliente={clienteSelected} />
                                      : (modalBody === 'topProductos2') ?
                                        <TopProductos2 topProductos={ventasProductos2} />
                                        : null
                    }
                  </>
              }
            </div>

            {/* Div para móvil */}
            <div className='d-sm-block d-md-none'>
              {
                (loading) ?
                  <div style={{ position: 'fixed', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
                    <div className="loader-book">
                      <div>
                        <ul>
                          <li>
                            <svg fill="currentColor" viewBox="0 0 90 120">
                              <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
                            </svg>
                          </li>
                          <li>
                            <svg fill="currentColor" viewBox="0 0 90 120">
                              <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
                            </svg>
                          </li>
                          <li>
                            <svg fill="currentColor" viewBox="0 0 90 120">
                              <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
                            </svg>
                          </li>
                          <li>
                            <svg fill="currentColor" viewBox="0 0 90 120">
                              <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
                            </svg>
                          </li>
                          <li>
                            <svg fill="currentColor" viewBox="0 0 90 120">
                              <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
                            </svg>
                          </li>
                          <li>
                            <svg fill="currentColor" viewBox="0 0 90 120">
                              <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
                            </svg>
                          </li>
                        </ul>
                      </div>
                      <span>Cargando {modalLoading}...</span>
                    </div>
                  </div> :
                  <>
                    {
                      (modalBody === 'pedidosPorDia') ?
                        <>
                          <div className="row my-4">
                            {
                              zonasSupervisor.map((Zona) =>
                                <div className='col'>
                                  <button className='buttonMonths w-100' onClick={(e) => setZonaSelected(Zona.Sector)}><span className="text-white">{Zona.Sector}</span>
                                  </button>
                                </div>)
                            }
                            <div className="col"><button className='buttonMonths w-100' onClick={(e) => setZonaSelected('General')}><span className="text-white">General</span></button></div>
                          </div>
                          <h5 className='text-belmeny my-2 ps-2'>Zona seleccionada: {zonaSelected}</h5>
                          <Stack direction="row" spacing={10} alignItems="flex-start" className='mb-3'>
                            <DateRangePicker
                              appearance={"subtle"}
                              ranges={predefinedRanges}
                              placeholder="Buscar por fecha"
                              style={{ width: 300 }}
                              onChange={([startDate, endDate]) => {
                                setCurrentRange({ start: startDate, end: endDate });
                              }}
                              value={[currentRange?.start, currentRange?.end]}
                              className="border rounded-pill mb-2"
                              showOneCalendar
                              disabledDate={afterToday()}
                            />
                          </Stack>
                          <PedidosPorDiaTable key={zonaSelected + (currentRange ? 'RANGO' : 'AYER')} data={currentRange ? pedidosPorDia : pedidosPorDiaAyer} resumenFacturado={resumenFacturado} resumenPedido={resumenPedido} />
                        </> : (modalBody === 'topClientes') ?
                          <TopClientes topClientes={topClientes} supervisor={user.CodVendedor} loaded={'paretos'} />
                          : (modalBody === 'topVendedores') ?
                            <TopVendedores zonasSupervisor={zonasSupervisor} multipleTops={multipleTops} topData={topData} topData2={topData2} topData3={topData3} />
                            : (modalBody === 'topProductos') ?
                              <TopProductosSupervisor totalVendido={totalVendido} ventasProductos={ventasProductos} totalVendidoVert={totalVendidoVert} totalVendidoIngco={totalVendidoIngco} totalVendidoQuilosa={totalVendidoQuilosa} totalVendidoImou={totalVendidoImou} totalVendidoFleximatic={totalVendidoFleximatic} totalVendidoCorona={totalVendidoCorona} totalVendidoWadfow={totalVendidoWadfow} />
                              : (modalBody === 'corteSemanal') ?
                                <CorteSemanalSupervisor startPastWeek={startPastWeek} endPastWeek={endPastWeek} startCurrentWeek={startCurrentWeek} endCurrentWeek={endCurrentWeek} zonasSupervisor={zonasSupervisor} ventasSemanales={ventasSemanales} ventasGralZona={ventasGralZona} ventasSemanalesOtrasZonas={ventasSemanalesOtrasZonas} />
                                : (modalBody === 'topProductos2') ?
                                  <TopProductos2 topProductos={ventasProductos2} />
                                  : (modalBody === 'topAllClientes') ?
                                    <TopClientes topClientes={topAllClientes} supervisor={user.CodVendedor} loaded={'todos'} />
                                    : (modalBody === 'historicoCliente') ?
                                      <HistoricoCliente cliente={clienteSelected} />
                                      : (modalBody === 'cobranzasGerencia') ?
                                        <CobranzasGerencia mes={mesSelected} año={añoSelected} />
                                        : null
                    }
                  </>
              }
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}